import store from '@/store';
import {
  loginUser,
  logoutUser,
  newPasswordUser,
  fetchLoginUserInfo,
  getNssSessionCheck,
} from '@/api/auth';

const authStore = {
  namespaced: true,
  state: {
    isLoginSuccess: false,
    userInfo: '',
    userData: [],
    selectIdByUser: '',
    selectUser: '',
    token: '',
    userLanguage: '',
  },
  getters: {},
  mutations: {
    loginSuccess(state, userInfo) {
      state.isLoginSuccess = true;
      state.userInfo = userInfo;
      state.selectIdByUser = userInfo[0].deviceID;
      state.selectUser = userInfo[0].user;
      state.token = userInfo[0].token;
      state.userLanguage = userInfo[0].language;
    },
    setUserLanguage(state, language) {
      state.userLanguage = language;
    },

    authResetState(state) {
      state.isLoginSuccess = false;
      state.userInfo = '';
      state.userData = [];
      state.selectIdByUser = '';
      state.selectUser = '';
      state.token = '';
      state.userLanguage = '';
    },
    UserData(state, Obj) {
      state.userData = Obj;
    },
    DeviceChange(state, vmSelectedDevice) {
      state.selectIdByUser = vmSelectedDevice.DeviceID;
      store.state.deviceStore.selectDeviceNameByUser = vmSelectedDevice.DeviceName;
      store.state.deviceStore.selectDeviceModeByUser = vmSelectedDevice.DeviceMode;
    },
    UserInfoChange(state, userInfo) {
      state.selectIdByUser = userInfo.deviceID;
      state.userData[0].userDeviceID = userInfo.deviceID;
      state.userInfo[0].deviceID = userInfo.deviceID;
      state.userData[0].userName = userInfo.userName;
      state.userData[0].userEmail = userInfo.userEmail;
      state.userData[0].userLanguage = userInfo.userLanguage;
    },
  },
  actions: {
    async LOGIN(_, userData) {
      const { data } = await loginUser(userData);
      return data;
    },
    async LOGOUT({ commit }, userData) {
      const { data } = await logoutUser(userData);
      if (data.success == 'true') {
        commit('authResetState');
        commit('deviceStore/deviceResetState', null, { root: true }); // 다른 모듈의 뮤테이션 호출
      }
      return data;
    },
    async changeNewPassword(_, changeUserdata) {
      const { data } = await newPasswordUser(changeUserdata);
      return data;
    },
    async UserInfo({ commit }, Obj) {
      const { data } = await fetchLoginUserInfo(Obj);
      commit('UserData', data.entitys);
      return data;
    },
    async NssSessionCheck(_, userData) {
      const { data } = await getNssSessionCheck(userData);
      return data;
    },
  },
};

export { authStore };
